import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  // Load authenticated state from localStorage or default to false
  const [authenticated, setAuthenticated] = useState(() => {
    const storedAuth = localStorage.getItem("authenticated");
    return storedAuth ? JSON.parse(storedAuth) : false;
  });

  // Load basicHttpAuthString state from localStorage or default to false
  const [basicHttpAuthString, setBasicHttpAuthString] = useState(() => {
    return localStorage.getItem("basicHttpAuthString") || "";
  });

//  const [authenticated, setAuthenticated] = useState(false);
//  const [basicHttpAuthString, setBasicHttpAuthString] = useState("");

  // Update localStorage whenever authenticated state changes
  useEffect(() => {
    localStorage.setItem("authenticated", JSON.stringify(authenticated));
  }, [authenticated]);

  // Update localStorage whenever basicHttpAuthString changes
  useEffect(() => {
    localStorage.setItem("basicHttpAuthString", basicHttpAuthString);
  }, [basicHttpAuthString]);

  const TEST_DOMAIN = "ad-archive-test.cs.washington.edu"; // "ad-archive-test.cs.washington.edu";

  useEffect(() => {
    const domain = window.location.hostname;
    if (domain != TEST_DOMAIN) {
      setAuthenticated(true);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ authenticated, setAuthenticated, basicHttpAuthString, setBasicHttpAuthString }}>
      {children}
    </AuthContext.Provider>
  );
};

